module.exports = __webpack_public_path__ + "static/media/logo-prov-jabar.8d4793b3.png";